import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQualifiesList } from "../action/QualifiesAction";
import { Nav } from "react-bootstrap";

export default function Qualifies() {
  const dispatch = useDispatch();
  const { loading, error, qualifiesRecords } = useSelector(
    (s) => s.qualifiesList
  );

  const getQualifies = () => {
    dispatch(getQualifiesList());
  };

  useEffect(() => {
    if (!qualifiesRecords) {
        getQualifies();
    }
  }, [dispatch, qualifiesRecords]);

  return qualifiesRecords ? qualifiesRecords.map(rec=>(
    <option key={rec.Id} value={rec.Id}>{rec.QualifiesData}</option>
  )) : (
    <option value="">No Record Exist!</option>
  );
}
